module.exports = __webpack_public_path__ + "img/BF.70421576.svg";